// extracted by mini-css-extract-plugin
module.exports = {"screenSaver":"screenSaver_screenSaver__tAWBS","charging":"screenSaver_charging__3SVHU"};